export enum ReportSelectionTypeEnum {
  ALL = 'ALL',
  BY_CATEGORY = 'BY_CATEGORY',
  SINGLE = 'SINGLE',
}
